import {Component, OnInit} from '@angular/core';
import {OfferBasicBoxComponent} from '../offer-basic-box/offer-basic-box.component';
import {LanguageService} from '../../../../../services/language.service';
import {isNotNullOrUndefined} from 'codelyzer/util/isNotNullOrUndefined';
import {isNext} from '../../../../../../core/utils/utils';
import {OfferDestinyOptionType} from '../../../../../../core/enums/offer/offer-destiny-option-type.enum';

@Component({
  selector: 'app-offer-compare-box',
  templateUrl: './offer-compare-box.component.html',
  styleUrls: ['./offer-compare-box.component.scss']
})
export class OfferCompareBoxComponent extends OfferBasicBoxComponent implements OnInit {
  icon: string;
  isValueAmount: boolean;
  isNext: boolean = isNext();

  constructor(private lang: LanguageService) {
    super(lang);
  }

  ngOnInit() {
    this.setSelectedOption();
    this.setIsValueAmount();
    this.setOptionValue();
    this.setIcon();
  }

  setIcon(): void {
    if (this.selectedOption && this.selectedOption.type === OfferDestinyOptionType.BOOLEAN) {
      this.icon = this.getIcon();
    }
  }

  private getIcon(): string {
    if (this.lang.getBooleanOption(this.selectedOption.values)) {
      return 'check';
    } else {
      return this.isNext ? 'close' : '—';
    }
  }

  private setIsValueAmount(): void {
    const optionValue = this.lang.getTranslationForKey(this.selectedOption.values, 'value');
    this.isValueAmount = this.selectedOption && this.selectedOption.type === OfferDestinyOptionType.NUMBER && isNotNullOrUndefined(optionValue);
  }
}
